module.exports = __webpack_public_path__ + "img/smart7.860ee984.png";